<template>
    <form ref="form" :class="{ 'in-popup': inPopup }" @submit.prevent>
        <template v-if="!inPopup">
            <!-- <topSearch></topSearch> -->
            <!-- <breadcrumb></breadcrumb> -->

            <div class="top-title-content">
                <span class="title">상품관리</span>
                <span class="txt">센터에서 이용 중인 이용권과 패키지를 등록 및 수정하고 설정할 수 있습니다.</span>
            </div>

            <div class="com-tab">
                <router-link :to="{ name: 'SettingGoodsUse' }" class="on">이용권 관리</router-link>
                <!-- <router-link :to="{ name: 'SettingGoodsPackage' }">패키지 관리</router-link> -->
                <router-link :to="{ name: 'SettingGoodsCategory' }">카테고리 관리</router-link>
            </div>

            <p class="sub-title">
                이용권 등록
                <a class="com-btn right" href="/madmin/setting/goods/use">목록보기</a>
            </p>
        </template>

        <loading :active.sync='isLoading' :is-full-page="true" loader='bars' color="#fe9616" :width='40' :height='40' />

        <div class="com-table-wrap">
            <span class="top-title">
                <span class="title">기본정보</span>
            </span>
            <div class="com-card-input half-type full">
                <div class="line-box">
                    <div class="left-box">
                        <div class="line">
                            <span class="tit">
                                이용권 구분
                                <span class="imp">*</span>
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">이용권 구분</span>
                                        <p class="txt">
                                            개인/OT : 1:1 예약제 레슨권. 정규수업과 OT를 구분하고 싶은 경우 나눠서
                                            사용하시면 좋습니다.
                                            <br />
                                            <br />
                                            듀엣 : 1:2 이상으로 진행하는 예약제 레슨으로 인원이 다수일 뿐 개인레슨과 비슷한
                                            성격을 갖습니다.
                                            <br />
                                            <br />
                                            그룹/쿠폰 : 그룹레슨관리에 등록된 그룹수업에 예약이 가능한 그룹레슨권. 편의상
                                            구분을 위해 그룹/쿠폰으로 나눠놓았을 뿐 같은 성격을 갖습니다.
                                            <br />
                                            <br />
                                            회원권 : 일반적인 자유 이용권 (예약 불가)
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <!-- 이 부분은 이용권을 등록할 때 보이는 부분으로 이용권의 종류를 선택할 수 있습니다. -->
                            <div v-if="status === 'create'" class="input-cnt">
                                <div v-for="(item, index) in ticketTypes" :key="index" class="com-box-radio">
                                    <input
                                        :id="'ticket-type-' + index"
                                        v-model="data.ticketType"
                                        :value="item.value"
                                        name="ticket-type"
                                        required
                                        type="radio"
                                    />
                                    <label :for="'ticket-type-' + index">{{ item.text }}</label>
                                </div>
                            </div>

                            <!-- 이 부분은 이용권을 수정하거나 상세히 보기를 원할 때 보이는 부분으로, 여기서는 오직 등록된 이용권의 종류만 알 수 있으며, 추후에 수정이 불가능합니다. -->
                            <div v-else-if="status === 'edit'" class="input-cnt">
                                <div class="com-box-radio">
                                    <input v-model="data.ticketType" :value="currentTicketInfo.value" type="radio" />
                                    <label>{{ currentTicketInfo.text }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                이용권 명
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <input
                                    v-model="data.name"
                                    class="w640"
                                    placeholder="예 ) 개인레슨 10회"
                                    required
                                    type="text"
                                />
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">이용권 설명</span>
                            <div class="input-cnt">
                                <input
                                    v-model="data.productComment"
                                    class="w640"
                                    placeholder="이용권 설명이 필요한 경우 입력해주세요"
                                    type="text"
                                />
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                카테고리
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">카테고리</span>
                                        <p class="txt">
                                            상품관리>카테고리관리에서 설정한 내용이 선택박스에 보여집니다.
                                            <br />
                                            <br />
                                            비슷한 이용권을 카테고리로 묶어서 관리하면 편리합니다.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <check-form
                                    :check-data="categories.map((c) => c.name)"
                                    :check-field-names="categories.map((c) => c.centerProductCategoryTemplateId)"
                                    :check-id="data.centerProductId"
                                    :check-values="selectedCategories"
                                    :disabled="data.ticketType === 'S'"
                                    @on-change="changeCategory"
                                ></check-form>
                            </div>
                        </div>
                    </div>

                    <div class="right-box">
                        <div class="line" v-if='centerInfo.kioskYn'>
                            <span class="tit">
                                키오스크에서 사용여부
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">키오스크에서 사용여부</span>
                                        <p class="txt">
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input
                                        id="radio-s10-1"
                                        v-model="data.kioskUsable"
                                        :value="true"
                                        name="radio-s10"
                                        type="radio"
                                    />
                                    <label for="radio-s10-1">사용가능</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-s10-2"
                                        v-model="data.kioskUsable"
                                        :value="false"
                                        name="radio-s10"
                                        type="radio"
                                    />
                                    <label for="radio-s10-2">사용불가</label>
                                </div>
                            </div>
                        </div>

                        <div class="line" v-if='centerInfo.kioskYn && data.kioskUsable'>
                            <span class="tit">
                                대표 이미지
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">대표 이미지</span>
                                        <p class="txt">
                                            권장 사이즈 1234x234 용량600kb 이하
                                        </p>
                                    </div>
                                </div>
                            </span>

                            <div class="input-cnt" style="position: relative; width: 250px; height: 160px; border: 1px solid #E1E1E1; justify-content: center" @click='onCoverImagePicker'>
                                <b-form-file
                                    ref='coverImageInput'
                                    id="file1"
                                    accept=".jpg, .png, .gif"
                                    plain
                                    @change="onChangeCoverImage"
                                    hidden
                                />

                                <img :src="data.coverImageUrl" alt="사진" v-if='data.coverImageUrl' style='width: 100%; height: 100%; object-fit: cover;' />
                                <div v-else style='text-align: center; align-self: center'>
                                    <img src="/img/icons/ic_big_plus.png" style="width: 20px" />
                                    <div class="add-title" style="font-size: 14px; font-weight: 500; color: #808080; margin-top: 8px">이미지 추가</div>
                                </div>

                                <button v-if='data.coverImageUrl' class='com-btn red' style='position: absolute; right: 8px; top: 8px;' @click.stop="onDeleteCoverImage">
                                    삭제
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="line-box">
                    <div class="left-box">
                        <div class="line">
                            <span class="tit">
                                유효기간
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <input v-model="data.periodCount" class="center w90" required type="text" />
                                <div class="com-radio">
                                    <input
                                        id="radio-s1-1"
                                        v-model="data.periodType"
                                        checked
                                        name="radio-s1"
                                        type="radio"
                                        value="M"
                                    />
                                    <label for="radio-s1-1">개월</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-s1-2"
                                        v-model="data.periodType"
                                        name="radio-s1"
                                        type="radio"
                                        value="D"
                                    />
                                    <label for="radio-s1-2">일</label>
                                </div>
                            </div>
                        </div>
                        <div class="line" v-if="data.ticketType !== 'S'">
                            <span class="tit">
                                횟수
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <!-- 총 N회 라디오 버튼 -->
                                <div v-show="['T'].indexOf(data.ticketType) < 0" class="com-radio">
                                    <input
                                        id="radio-s2-1"
                                        v-model="data.lessonCountType"
                                        checked
                                        name="radio-s2"
                                        type="radio"
                                        value="T"
                                    />
                                    <label v-show="['T'].indexOf(data.ticketType) < 0" for="radio-s2-1">총 횟수</label>
                                </div>
                                <input
                                    v-show="['T'].indexOf(data.ticketType) < 0"
                                    v-model="lessonCountTotal"
                                    :disabled="data.lessonCountType !== 'T'"
                                    class="center w90"
                                    placeholder="예) 3"
                                    type="text"
                                    @keypress="isNumber($event)"
                                />
                                <span v-show="['T'].indexOf(data.ticketType) < 0" class="txt">회</span>

                                <!-- 주당 N회 라디오 버튼 -->
                                <div v-show="['P', 'O', 'D', 'T'].indexOf(data.ticketType) < 0" class="com-radio">
                                    <input
                                        id="radio-s2-2"
                                        v-model="data.lessonCountType"
                                        name="radio-s2"
                                        type="radio"
                                        value="W"
                                    />
                                    <label for="radio-s2-2">주</label>
                                </div>
                                <input
                                    v-show="['P', 'O', 'D', 'T'].indexOf(data.ticketType) < 0"
                                    v-model="lessonCountWeek"
                                    :disabled="data.lessonCountType !== 'W'"
                                    class="center w90"
                                    placeholder="예) 3"
                                    type="text"
                                    @keypress="isNumber($event)"
                                />
                                <span v-show="['P', 'O', 'D', 'T'].indexOf(data.ticketType) < 0" class="txt">회</span>

                                <!-- 무제한 라디오 버튼 -->
                                <div v-show="['P', 'O', 'D'].indexOf(data.ticketType) < 0" class="com-radio">
                                    <input
                                        id="radio-s2-3"
                                        v-model="data.lessonCountType"
                                        name="radio-s2"
                                        type="radio"
                                        value="U"
                                    />
                                    <label for="radio-s2-3">
                                        무제한
                                        <small>(횟수제한 없는 자유이용)</small>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="line" v-if="data.ticketType !== 'S'">
                            <span class="tit">
                                수업시간
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">수업시간</span>
                                        <p class="txt">
                                            기본은 1시간당 1회를 기준으로 합니다.
                                            <br />
                                            필요할 경우 수업시간 당 강사의 수업횟수에 몇 회로 포함할 지 변경할 수
                                            있습니다.
                                            <br />
                                            <br />

                                            예) 30분의 수업을 강사에게 1회라고 인정하는 센터도 있는 반면, 0.5회로
                                            적용하는 센터도 있습니다.
                                            <br />
                                            <br />

                                            여기서 적용한 시간 당 횟수는 급여 메뉴에서 확인하는 강사의 총 수업횟수를
                                            합산하는데 적용됩니다.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="top-txt">
                                    <span class="txt">1회 당</span>
                                    <select-form
                                        :select-data="['시간 선택', '30분', '1시간', '1시간 30분', '2시간']"
                                        :select-value="[0, 30, 60, 90, 120]"
                                        :selected-value.sync="data.lessonTime"
                                        class="w180"
                                    />
                                    <!--                                        @update:set="changeLessonTime"-->
                                </div>
                                <div class="top-txt">
                                    <span class="txt">강사에게</span>
                                    <select-form
                                        :select-data="['횟수 선택', '0.5회', '1회', '1.5회', '2회']"
                                        :select-value="[0, 0.5, 1, 1.5, 2]"
                                        :selected-value.sync="data.lessonPerLessonCount"
                                        class="w180"
                                        @update:set="(v) => $forceUpdate()"
                                    />
                                    <span class="sub-txt">의 수업으로 적용합니다.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right-box">
                        <div class="line">
                            <span class="tit">
                                금액
                                <span class="imp">* 숫자만 기입해주세요</span>
                            </span>
                            <div class="input-cnt">
                                <input
                                    v-model="data.sellPrice"
                                    class="center w220"
                                    type="text"
                                    @input="data.sellPrice = data.sellPrice.replace(/[^0-9]/g, '')"
                                />
                                <span class="txt">원</span>
                            </div>
                        </div>
                        <div class="line" v-if="data.ticketType !== 'S'">
                            <span class="tit">
                                회당단가
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">회당단가</span>
                                        <p class="txt">
                                            이용권의 1회 당 단가를 보여줍니다.
                                            <br />
                                            ※ 주 N회의 경우는 유효기간에 따라 전체 횟수가 다를 수 있으므로 평균금액으로
                                            보여지며 정확하지 않을 수 있습니다.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <input
                                    :value="getPricePerTime() === 'Infinity' ? 0 : getPricePerTime()"
                                    class="center w220"
                                    readonly
                                    type="text"
                                />
                                <span class="txt">원</span>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                부가세
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">부가세</span>
                                        <p class="txt">
                                            설정한 부가세는 매출에 적용됩니다.
                                            <br />
                                            강사의 급여가 %인 경우, 부가세를 제외하고 정산하는 것은 강사개별급여
                                            설정에서 적용해주세요.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input
                                        id="radio-s3-1"
                                        v-model="data.vatYn"
                                        :value="false"
                                        name="radio-s3"
                                        type="radio"
                                    />
                                    <label for="radio-s3-1">부가세 미적용</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-s3-2"
                                        v-model="data.vatYn"
                                        :value="true"
                                        checked
                                        name="radio-s3"
                                        type="radio"
                                    />
                                    <label for="radio-s3-2">부가세 10% 적용</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                판매여부
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">판매여부</span>
                                        <p class="txt">
                                            이용권 판매를 잠시 중단해야 하는 경우 '판매정지’를 선택하여 이용권 판매를
                                            중지할 수 있습니다.
                                            <br />
                                            추후 다시 '판매중'으로 변경 가능합니다.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input
                                        id="radio-s4-1"
                                        :checked="this.data.stockUseYn"
                                        :value="true"
                                        name="radio-s4"
                                        type="radio"
                                        @click="changeStockUseYn"
                                    />
                                    <label for="radio-s4-1">판매중</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-s4-2"
                                        :checked="!this.data.stockUseYn"
                                        :value="false"
                                        name="radio-s4"
                                        type="radio"
                                        @click="changeStockUseYn"
                                    />
                                    <label for="radio-s4-2">판매정지</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="!['D', 'T', 'S'].includes(data.ticketType)" class="com-table-wrap">
            <span class="top-title">
                <span class="title">예약설정</span>
            </span>
            <div class="com-card-input half-type full">
                <div class="line-box">
                    <div class="left-box">
                        <div class="line">
                            <span class="tit">
                                회원예약 어플리케이션을 통해 회원이 직접 예약할 수 있도록 하시겠습니까?
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <p class="txt">
                                            해당 이용권이 회원예약 어플리케이션을 통해 수업예약이 가능한지 여부를
                                            설정합니다.
                                            <br />
                                            '아니오'로 설정한 경우 회원은 예약할 수 없으며 관리자버전에서만 가능합니다.
                                            <br />
                                            자세한 예약제한 시간은 [센터설정>예약시간설정>회원예약 앱] 메뉴에서
                                            설정해주세요.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input
                                        id="radio-s5-1"
                                        v-model="data.resvAppYn"
                                        :value="true"
                                        name="radio-s5"
                                        type="radio"
                                    />
                                    <label for="radio-s5-1">네</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-s5-2"
                                        v-model="data.resvAppYn"
                                        :value="false"
                                        name="radio-s5"
                                        type="radio"
                                    />
                                    <label for="radio-s5-2">아니오</label>
                                </div>
                            </div>
                        </div>
                        <div v-show="data.resvAppYn" class="line">
                            <span class="tit">
                                당일중복예약
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">당일중복예약</span>
                                        <p class="txt">
                                            스케줄 예약 시, 당일 중복예약이 가능한지 설정합니다. '하루 여러 번
                                            예약가능'으로 선택 시, 하루에 두 번 이상 스케줄 예약이 가능합니다.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input
                                        id="radio-s6-1"
                                        v-model="data.resvDayDupYn"
                                        :value="true"
                                        checked
                                        name="radio-s6"
                                        type="radio"
                                    />
                                    <label for="radio-s6-1">하루 '여러 번' 예약 가능</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-s6-2"
                                        v-model="data.resvDayDupYn"
                                        :value="false"
                                        name="radio-s6"
                                        type="radio"
                                    />
                                    <label for="radio-s6-2">하루 '한 번' 예약 가능</label>
                                </div>
                            </div>
                        </div>
                        <div v-show="data.resvAppYn" class="line">
                            <span class="tit">
                                취소횟수 제한
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">취소횟수 제한</span>
                                        <p class="txt">
                                            회원APP에서 예약된 수업에 대해 한 주에 몇 번 취소가 가능한지 설정 할 수
                                            있습니다.
                                            <br />
                                            관리자버전에서는 취소횟수제한과 상관없이 예약취소 가능합니다.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input
                                        id="radio-s7-1"
                                        v-model="data.resvCancelType"
                                        checked
                                        name="radio-s7"
                                        type="radio"
                                        value="U"
                                    />
                                    <label for="radio-s7-1">무제한</label>
                                </div>

                                <div class="com-radio">
                                    <input
                                        id="radio-s7-2"
                                        v-model="data.resvCancelType"
                                        name="radio-s7"
                                        type="radio"
                                        value="W"
                                    />
                                    <label for="radio-s7-2">주당</label>
                                </div>
                                <input
                                    v-model="data.resvCancelCount"
                                    v-show="data.resvCancelType == 'W'"
                                    class="center w90"
                                    placeholder="예) 3"
                                    type="text"
                                />
                                <span class="txt" v-show="data.resvCancelType == 'W'">회</span>

                                <div class="com-radio">
                                    <input
                                        id="radio-s7-3"
                                        v-model="data.resvCancelType"
                                        name="radio-s7"
                                        type="radio"
                                        value="T"
                                    />
                                    <label for="radio-s7-3">총</label>
                                </div>
                                <input
                                    v-model="data.resvCancelCount"
                                    v-show="data.resvCancelType == 'T'"
                                    class="center w90"
                                    placeholder="예) 3"
                                    type="text"
                                />
                                <span class="txt" v-show="data.resvCancelType == 'T'">회</span>
                            </div>
                        </div>
                    </div>
                    <div v-show="data.resvAppYn" class="right-box">
                        <div class="line">
                            <span class="tit">
                                예약횟수 제한
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">예약횟수 제한</span>
                                        <p class="txt">
                                            이용권의 주당 사용 횟수를 제한합니다. 관리자 및 회원예약 어플리케이션에서
                                            스케줄 예약 시 적용됩니다.
                                            <br />
                                            예1) 총 횟수 10회 이면서 예약횟수 제한을 주 2회로 설정한 경우, 주당 2회씩만
                                            예약사용 가능함.
                                            <br />
                                            예2) 횟수 주 2회인 경우 예약횟수 제한은 주 2회로 자동 설정됨.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input
                                        id="radio-s8-1"
                                        v-model="data.resvLimitType"
                                        :disabled="data.lessonCountType === 'W'"
                                        name="radio-s8"
                                        type="radio"
                                        value="U"
                                        @click="onClickInfinityReservation"
                                    />
                                    <label for="radio-s8-1">무제한</label>
                                </div>

                                <div class="com-radio">
                                    <input
                                        id="radio-s8-2"
                                        v-model="data.resvLimitType"
                                        name="radio-s8"
                                        type="radio"
                                        value="W"
                                    />
                                    <label for="radio-s8-2">주당</label>
                                </div>
                                <input
                                    v-model="data.resvLimitCount"
                                    v-show="data.resvLimitType == 'W'"
                                    class="center w90"
                                    placeholder="예) 3"
                                    type="text"
                                />
                                <span class="txt" v-show="data.resvLimitType == 'W'">회</span>

                                <div class="com-radio">
                                    <input
                                        id="radio-s8-3"
                                        v-model="data.resvLimitType"
                                        :disabled="data.lessonCountType === 'W'"
                                        name="radio-s8"
                                        type="radio"
                                        value="T"
                                    />
                                    <label for="radio-s8-3">총</label>
                                </div>
                                <input
                                    v-model="data.resvLimitCount"
                                    v-show="data.resvLimitType == 'T'"
                                    class="center w90"
                                    placeholder="예) 3"
                                    type="text"
                                />
                                <span class="txt" v-show="data.resvLimitType == 'T'">회</span>
                            </div>
                        </div>

                        <div v-show="data.ticketType === 'G' || data.ticketType === 'C'" class="line">
                            <span class="tit">
                                대기횟수 제한
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">대기횟수 제한</span>
                                        <p class="txt">
                                            예약 대기 가능한 횟수를 제한합니다.<br />
                                            0을 입력하거나 값을 입력하지 않은 경우 예약 대기 기능을 사용할 수 없습니다.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input
                                        id="radio-s9-1"
                                        v-model="data.waitLimitType"
                                        name="radio-s9"
                                        type="radio"
                                        value="U"
                                    />
                                    <label for="radio-s9-1">무제한</label>
                                </div>

                                <div class="com-radio">
                                    <input
                                        id="radio-s9-2"
                                        v-model="data.waitLimitType"
                                        name="radio-s9"
                                        type="radio"
                                        value="W"
                                    />
                                    <label for="radio-s9-2">주당</label>
                                </div>
                                <the-mask
                                    v-model.number="data.waitLimitCount"
                                    v-show="data.waitLimitType === 'W'"
                                    class="center w90"
                                    placeholder="예) 3"
                                    mask='##'
                                />
                                <span class="txt" v-show="data.waitLimitType === 'W'">회</span>

                                <div class="com-radio">
                                    <input
                                        id="radio-s9-3"
                                        v-model="data.waitLimitType"
                                        name="radio-s9"
                                        type="radio"
                                        value="T"
                                    />
                                    <label for="radio-s9-3">총</label>
                                </div>
                                <the-mask
                                    v-model.number="data.waitLimitCount"
                                    v-show="data.waitLimitType === 'T'"
                                    class="center w90"
                                    placeholder="예) 3"
                                    mask='##'
                                />
                                <span class="txt" v-show="data.waitLimitType === 'T'">회</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--
        고객 요구에 의해서 삭제함.
        <div class="com-table-wrap">
            <span class="top-title">
                <span class="title">교차수강</span>
            </span>
            <div class="com-card-input half-type full">
                <div class="line-box">
                    <div class="left-box">
                        <div class="line">
                            <span class="tit">
                                교차수강 여부
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">교차수강 여부</span>
                                        <p class="txt">
                                            체인점으로 설정된 경우, 구매한 지점과 상관 없이 다른 지점에서 사용할 수
                                            있는지 여부를 설정합니다.<br />
                                            해당 이용권을 A지점에서 구매 후 B지점에서 사용 시, 소진매출은 A지점에
                                            적용되고, 급여는 B지점의 수업한 강사에게 정산됩니다.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input
                                        v-model="data.lessonCrossYn"
                                        type="radio"
                                        name="radio-s9"
                                        id="radio-s9-1"
                                        :value="true"
                                        checked
                                    />
                                    <label for="radio-s9-1">가능</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        v-model="data.lessonCrossYn"
                                        type="radio"
                                        name="radio-s1"
                                        id="radio-s9-2"
                                        :value="false"
                                    />
                                    <label for="radio-s9-2">불가능</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        -->

        <div v-if="editOrDelete" class="line-gap">
            <div class="com-btn-area">
                <div class="right-box">
                    <!--  editOrDelete === true  -->
                    <button class="com-btn red" type="button" @click="remove">삭제</button>
                </div>
            </div>
        </div>
        <div class="bottom-btn">
            <button class="com-btn" type="reset" @click="cancel">취소</button>
            <button class="com-btn blue" type="submit" @click="save" v-html="prodNo && !inPopup ? '수정' : '추가'" />
        </div>
    </form>
</template>

<script>
import {TheMask} from 'vue-the-mask'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import api from '../../../assets/js/api';
import { TICKET_INFO } from '@/assets/js/common';

export default {
    name: 'SettingGoodsUseDetail',
    components: {Loading, TheMask },
    props: {
        inPopup: {
            type: Boolean,
            default: false,
        },
        deletable: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        centerId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        selectedCategories() {
            if (this.prodNo) {
                const selected = [];
                this.categories.forEach((o) => {
                    selected.push(
                        (this.data.categorys || []).filter(
                            (e) => e.centerProductCategoryTemplateId == o.centerProductCategoryTemplateId
                        ).length > 0
                    );
                });
                return selected;
            }
            return Array(this.categories.length).fill(false);
        },

        // 현재 페이지의 상태를 알려주는 데이터
        status() {
            if (!this.prodNo) {
                return 'create'; // 이용권을 등록하는 상태
            }
            return 'edit'; // 이용권의 내용을 보거나 수정하는 상태
        },

        // 등록된 이용권의 이용권 유형의 정보를 알려주는 데이터
        currentTicketInfo() {
            if (this.status === 'edit') {
                return this.ticketTypes.find((item) => item.value === this.data.ticketType);
            }

            return null;
        },
    },
    data() {
        return {
            isLoading: false,
            // productTypes: [],
            ticketTypes: TICKET_INFO,
            categories: [],
            centerInfo: {},
            prodNo: null,
            data: {
                categorys: [], // 카테고리 정보
                lessonCount: 0, // 수업 횟수
                lessonCountType: 'T', // 수업 횟수 유형 코드(총횟수: T, 주당횟수: W, 무제한: U)
                lessonCrossYn: false, // 교차수강 가능 여부
                lessonPerLessonCount: 1, // 1회당 수업 수
                lessonStaffId: 0, // 담당 강사 직원 아이디
                lessonTime: 60, // 수업 소요 시간
                name: '', // 상품명(필수)
                periodCount: 0, // 유효기간 값
                periodType: 'M', // 유형 기간 유형 코드(월: M, 일: D)
                productComment: '', // 상품 설명
                productType: 'T', // 상품 유형 코드(이용권: T, 패키지: P, 락커: L, 트레이닝복: C, 부가서비스: S)(필수)
                resvAppYn: false, // 예약 앱 설정 가능여부
                resvCancelCount: 0, // 예약 취소제한 값
                resvCancelType: 'U', // 예약 취소제한 유형 코드(무제한: U, 주당제한수: W, 총제한수: T)
                resvDayDupYn: true, // 예약 당일중복 가능여부
                resvLimitCount: 0, // 예약 횟수 제한값
                resvLimitType: 'U', // 예약 횟수제한 유형 코드(무제한: U, 주당제한수: W, 총제한수: T)
                waitLimitCount: 0, // 예약 대기 횟수 제한값
                waitLimitType: 'U', // 예약 대기 횟수제한 유형 코드(무제한: U, 주당제한수: W, 총제한수: T)
                recvPrice: 0, // 공급가격
                sellPrice: 0, // 판매가격
                stockUseYn: true, // 판매여부
                stockManualYn: false, // 재고 직적입력 여부
                kioskUsable: false, // 키오스크에서 사용 여부
                coverImage: {
                    filename: '',
                    mimetype: '',
                    base64data: '',
                },
                coverImageUrl: '',
                ticketType: 'P', // 이용권 유형 코드(개인: P, OT: O, 듀엣: D, 그룹: G, 쿠폰: C, 회원권: T)
                turnBillPrice: 0, // 1회당 정산금액
                vatYn: false, // 부가세 여부(필수)
            },
            lessonCountWeek: 0, // 주당 횟수
            lessonCountTotal: 0, // 총 횟수
            editOrDelete: false,
        };
    },
    watch: {
        prodNo(v) {
            if (v) this.load();
        },
        // 주당 횟수와 주당 예약 제한 횟수를 연동하기 위해서 설정함
        lessonCountWeek(value) {
            if (this.data.lessonCountType === 'W') {
                this.data.resvLimitCount = value;
            }
        },
        'data.lessonCountType': function (value) {
            if (value === 'W') {
                this.data.resvLimitType = 'W';
                this.data.resvLimitCount = this.lessonCountWeek;
            } else if (value === 'T') {
                this.data.resvLimitType = 'W';
            } else {
                this.data.resvLimitType = 'U';
            }
        },
        'data.ticketType': function (value) {
            if (value === 'T') {
                this.data.lessonCountType = 'U';
            }
        },
    },
    async beforeMount() {
        // this.data = this.getDefault();

        /*
        (await this.$getSystemCode({ center_prod: ['prod_type_cd', 'ticket_type_cd'] })).forEach(o => {
            if (o[0].columnName == 'prod_type_cd') {
                this.productTypes = o.map(e => {
                    return { value: e.codeName, text: e.codeDesc };
                });
            } else if (o[0].columnName == 'ticket_type_cd') {
                this.ticketTypes = o.map(e => {
                    return { value: e.codeName, text: e.codeDesc };
                });
            }
        });
        */

        api.get(`/admin/api/center/${this.centerId}/product/category/template`)
            .then((res) => {
                this.categories = res.data || [];
            })
            .catch((res) => {
                if (res.response.status != 404) alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                console.error(res);
            });

        // 배열 위치 재정렬
        /*
        this.ticketTypes = this.moveElement(this.ticketTypes,4,-4)
        console.log(this.ticketTypes);
        this.ticketTypes = this.moveElement(this.ticketTypes,4,-3)
        console.log(this.ticketTypes);
        this.ticketTypes = this.moveElement(this.ticketTypes,2,2)
        console.log(this.ticketTypes);
        console.log(this.productTypes);
        */
    },
    mounted() {
        this.getCenter();

        this.prodNo = this.$route.query.prodNo;
        // this.load();
    },
    methods: {
        changeCategory(v) {
            if (
                v.value &&
                this.data.categorys.filter((o) => o.centerProductCategoryTemplateId == v.fieldName).length == 0
            ) {
                this.data.categorys.push({
                    centerProductCategoryTemplateId: v.fieldName,
                    name: v.data,
                });
            } else if (!v.value) {
                this.data.categorys.splice(
                    this.data.categorys.findIndex((o) => o.centerProductCategoryTemplateId == v.fieldName),
                    1
                );
            }
        },
        changeLessonTime(v) {
            this.data.lessonPerLessonCount = {
                30: 0.5,
                60: 1,
                90: 1.5,
                120: 2,
            }[v];
            this.$forceUpdate();
        },
        getPricePerTime() {
            switch (this.data.lessonCountType) {
                case 'U':
                    return '-';
                case 'W':
                    return Math.floor(
                        this.data.sellPrice /
                            (((this.data.periodCount * (this.data.periodType == 'M' ? 30 : 1)) / 7) *
                                this.lessonCountWeek *
                                this.data.lessonPerLessonCount)
                    ).toMoney();
                default:
                    return Math.floor(this.data.sellPrice / this.lessonCountTotal).toMoney();
            }
        },

        async getCenter() {
            const { data } = await api.get(`/admin/api/center/${this.centerId}`);

            this.centerInfo = data;
        },

        load() {
            const params = {
                startDate: 19700101,
                endDate: 23000502,
                centerProductIds: this.prodNo,
                page: 1,
                limit: 9999,
            };
            this.isLoading = true;
            // 스웨거 검색: 센터상품 조회
            Promise.all([
                api.get(`/admin/api/center/${this.centerId}/product/${this.prodNo}`, {
                    params: {
                        ...this.$route.query,
                        limit: 1,
                        centerProductId: this.prodNo,
                    },
                }),
            ])
            .then((response) => {
                const res = response[0];
                const res2 = response[1];

                this.isLoading = false;
                this.data = res.data;
                this.data.categorys = res.data.centerProductCategorys || [];
                if (!res.data.lessonTime) {
                    this.data.lessonTime = 60;
                }
                this.data.lessonPerLessonCount = Number(this.data.lessonPerLessonCount || 1);

                if (this.data.lessonCountType === 'T') {
                    this.lessonCountTotal = this.data.lessonCount;
                } else if (this.data.lessonCountType === 'W') {
                    this.lessonCountWeek = this.data.lessonCount;
                }

                if (!this.data.waitLimitType) {
                    this.data.waitLimitType = 'U';
                }

                if (this.data.sales === 0) {
                    this.editOrDelete = true;
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },



        save() {
            if (!this.$refs.form.checkValidity() || this.isLoading) {
                (
                    this.$refs.form.querySelector(':invalid') || {
                        focus() {},
                    }
                ).focus();
                return;
            }

            const error = false;

            if (error) return;

            if (this.data.lessonCountType === 'T') {
                this.data.lessonCount = this.lessonCountTotal;
            } else if (this.data.lessonCountType === 'W') {
                this.data.lessonCount = this.lessonCountWeek;
            } else {
                this.data.lessonCount = 0;
            }

            // 운동복은 무조건 무제한
            if (this.data.ticketType === 'S') {
                this.data.lessonCountType = 'U';
            }

            this.data.recvPrice = this.data.sellPrice;

            this.isLoading = true;

            const params = { ...this.data }

            if (params.coverImageUrl && !params.coverImageUrl.startsWith('http')) {
                delete params.coverImageUrl;
            }
            if (params.coverImage && !params.coverImage.filename) {
                delete params.coverImage;
            }

            (this.prodNo
                ? api.put(`/admin/api/center/${this.centerId}/product/${this.prodNo}`, params)
                : api.post(`/admin/api/center/${this.centerId}/product`, params)
            )
                .then((res) => {
                    this.isLoading = false;
                    if (this.inPopup) {
                        this.$emit('select', this.data);
                        return;
                    }
                    alert('저장했습니다.');
                    if (this.prodNo) {
                        this.$router.back();
                    } else {
                        this.$router.back();
                    }
                })
                .catch((res) => {
                    this.isLoading = false;
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        remove(event) {
            if (!confirm('정말로 삭제하시겠습니까??')) {
                return;
            }
            event.target.disabled = true;
            api.delete(`/admin/api/center/${this.centerId}/product/${this.prodNo}`)
                .then((res) => {
                    alert('삭제했습니다.');
                    this.$router.push({ name: 'SettingGoodsUse', query: this.$route.query });
                })
                .catch((res) => {
                    event.target.disabled = false;
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },

        // 취소 버튼을 눌렀을 때 기능을 정의하는 함수
        cancel() {
            if (this.inPopup) {
                // 패키지 등록 페이지에서 이용권을 추가하거나 새로 생성할 때,
                // 해당 이용권 등록 및 추가 페이지를 닫을 때에는 이전 페이지로 돌아가도록 설정함.
                this.$emit('cancel-popup');
            } else {
                // 이용권 관리 페이지에서 이용권 등록 페이지로 들어갈 때,
                // 취소 버튼을 누르게 되면 이용권 관리 페이지로 넘어가도록 설정함.
                // this.$router.push({ name: 'SettingGoodsUse' });
                this.$router.back();
            }
        },

        // 입력 폼에 숫자만 입력하도록 강제하는 함수
        isNumber(evt) {
            evt = evt || window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        // 등록된 이용권을 수정할 때, 판매 여부에서 판매 중지를 선택할 때 알람창을 띄우는 함수
        changeStockUseYn(event) {
            const value = event.target.value === 'true';
            if (this.status === 'create') {
                // 이용권을 신규 등록할 때, 판매여부에서는 따로 알림창을 띄우지 않는다.
                this.data.stockUseYn = value;
                console.log('동작');
            } else if (this.status === 'edit') {
                // 이용권을 수정하려고 할 때는 아래의 조건을 따른다.
                if (value) {
                    // 첫 번째로 선택된 부분이 '판매중'(true)이면 정상적으로 동작을 합니다.
                    this.data.stockUseYn = true;
                    console.log('동작');
                } else {
                    // 두 번째 선택된 부분이 '판매중단'(false)라고 한다면 아래의 2가지 경우로 나눕니다.
                    if (this.data.stockUseYn) {
                        // 원래 판매 중인 이용권을 판매 중단하려는 경우에는 알림창을 띄웁니다.
                        if (confirm('정말로 판매정지 하시겠습니까?')) {
                            // 이 때 사용자가 확인 버튼을 누르면 이벤트를 정상적으로 작동하게 만듭니다.
                            this.data.stockUseYn = false;
                        } else {
                            // 만일 사용자가 취소 버튼을 누르면 이벤트를 도중에 중단시킵니다.
                            event.preventDefault();
                        }

                        // 원래 판매 중단인 이용권에 대해서 판매 중단을 누르게 되는 경우에는 어떠한 알림창도 띄위지 않습니다.
                    }
                }
            }
        },

        onClickInfinityReservation() {
            this.data.resvLimitCount = 0;
        },

        onCoverImagePicker() {
            this.$refs.coverImageInput.$refs.input.click();
        },

        onChangeCoverImage(e) {
            const file = e.target.files[0];
            this.data.coverImage = {
                filename: file.name,
                mimetype: file.type
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                this.data.coverImageUrl = e.target.result;
                this.data.coverImage.base64data = this.data.coverImageUrl.split(',')[1];
            };
            reader.readAsDataURL(file);

            this.$refs.coverImageInput.reset();
        },

        onDeleteCoverImage(e) {
            this.data.coverImageUrl = null;
            this.data.coverImage = {};
        }
    },
};
</script>
<style lang="scss" scoped>
.in-popup {
    .com-table-wrap {
        padding-bottom: 50px;
    }

    .top-title {
        background-color: #fff;
        border-bottom: 1px solid #666;
        margin: 0 30px 33px;
    }

    .bottom-btn {
        position: sticky;
        bottom: 0;
        padding: 16px;
        background-color: #fff;
        text-align: right;
    }
}
</style>
